import { render, staticRenderFns } from "./EmployeeBorrow.vue?vue&type=template&id=5b54e4e1&scoped=true&"
import script from "./EmployeeBorrow.vue?vue&type=script&lang=js&"
export * from "./EmployeeBorrow.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBorrow.vue?vue&type=style&index=0&id=5b54e4e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54e4e1",
  null
  
)

export default component.exports